import { useEffect } from "react";
import { useHistory } from "react-router";
import { useI18n } from "i18n";
import { PageLoader } from "@remo-co/ui-core/src/components/PageLoader";

const HomePage = () => {
  const history = useHistory();
  const { t } = useI18n();

  useEffect(() => {
    history.push("/my-events");
  }, [history]);

  return <PageLoader data-testid="home-page-loader" message={t("loading")} />;
};

export default HomePage;
